import { Component, OnInit, Inject } from '@angular/core';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA, MdSelectModule } from '@angular/material';

import { ValidationService } from '../../../shared/services/validation.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';

import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { CentreModel } from '../../../models/centre/centre.model';
import { ManageCentreService } from './manage-centre.service';
import { UserType } from '../../../shared/constants/permission';
import { SharedService } from '../../../shared/services/share.services';
import { NullTemplateVisitor } from '@angular/compiler';

@Component({
  selector: 'centre-popup',
  templateUrl: './centre-popup.component.html',
  providers: [ManageCentreService, SharedService]
})
export class CentrePopupComponent implements OnInit {
  public fileErrorMessage = ValidationService.getValidatorErrorMessage('invalidFile');
  public defaultCountry = null;
  public usertype = null;
  public addCentreForm: FormGroup;
  public centreModel = new CentreModel;
  public title: string;
  public defaultGroupOption = 'Add a new group';
  public logoImage: File = null;
  public signatureImage: File = null;
  public countryData: any[];
  public currencyData: any[];
  public groupData: any[];
  public vatData: any[];
  public centreData: any[];
  public timeZones: any[];
  constructor(private formBuilder: FormBuilder,
    public utility: Utility,
    private manageCentreService: ManageCentreService,
    public dialogService: DialogService,
    private sharedService: SharedService,
    public dialogRef: MdDialogRef<CentrePopupComponent>,
    @Inject(MD_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    this.initData();
    if (this.data.id) {
      this.title = 'Edit Centre';
      this.createForm();
      this.getCentreInfo();
      ValidationService.removeValidators(this.addCentreForm.controls['CentreCloneId']);
      // UC100: Not allow changing default currency when editing centre
      this.addCentreForm.controls['CurrencyId'].enable();
      this.usertype = localStorage.getItem(AppConstants.localStorage.userType);
    } else {
      this.title = 'Add Centre';
      this.defaultCountry = localStorage.getItem(AppConstants.localStorage.countryId);
      this.createForm();
      this.usertype = localStorage.getItem(AppConstants.localStorage.userType);
    }
  }

  createForm() {
    this.addCentreForm = this.formBuilder.group({
      Code: ['', [Validators.required]],
      Name: ['', [Validators.required]],
      SubTitle: '',
      Address1: '',
      Address2: '',
      Address3: '',
      Address4: '',
      CountryId: [this.defaultCountry, [Validators.required]],
      Tel: '',
      Fax: '',
      Email: ['', [Validators.required, ValidationService.isValidEmail]],
      ReportEmail: ['', [ValidationService.isValidEmail]],
      Web: '',
      Contact: '',
      Custom1: '',
      Custom2: '',
      Custom3: '',
      Custom4: '',
      BankName: '',
      BankAddress: '',
      BankSortCode: '',
      BankAccount: '',
      AccountName: '',
      BankSwifCode: '',
      IBAN: '',
      // TimeZoneId: ['', [Validators.required]],
      CurrencyId: [null, [Validators.required]],
      Group: [this.defaultGroupOption, [Validators.required]],
      NewGroup: ['', [Validators.required]],
      VatId: [],
      Active: false,
      IsClinicLogoDelete: false,
      ClinicLogoName: '',
      IsSignatureDelete: false,
      SignatureName: '',
      CentreCloneId: [null,  null],
      AssociatedClinic: false,
    });
  }

  initData() {
    this.getVATCharge();
    this.getCountryData();
    this.getGroupData();
    this.getCurrencyData();
    this.getTimeZone();
  }
  getVATCharge() {
    this.manageCentreService.getVATCharge().subscribe(
      (result) => {
        if (result) {
          this.vatData = result.json();
        }
      }
    );
  }
  getCurrencyData() {
    this.manageCentreService.getCurrencyList().subscribe(
      (result) => {
        if (result) {
          this.currencyData = result.json();
        }
      }
    );
  }

  getCountryData() {
    this.manageCentreService.getUserCountryList().subscribe(
      (result) => {
        if (result) {
          this.countryData = result.json();
        }
      }
    );
  }

  getGroupData() {
    this.manageCentreService.getCentreGroupList().subscribe(
      (result) => {
        if (result) {
          this.groupData = result.json();
        }
      }
    );
  }

  getTimeZone() {
    this.manageCentreService.getTimeZoneList().subscribe(
      result => {
        if (result) {
          this.timeZones = result.json();
        }
      }
    );
  }

  getCentreInfo() {
    this.manageCentreService.getCentreDetail(this.data.id).subscribe(
      (result) => {
        const data = result.json();
        this.centreModel = data;
        this.centreModel.address1 = data.addresses[0];
        this.centreModel.address2 = data.addresses[1];
        this.centreModel.address3 = data.addresses[2];
        this.centreModel.address4 = data.addresses[3];
        this.centreModel.custom1 = data.customs[0];
        this.centreModel.custom2 = data.customs[1];
        this.centreModel.custom3 = data.customs[2];
        this.centreModel.custom4 = data.customs[3];
        this.centreModel.currencyId = data.currencyId;
        this.centreModel.contact = data.contactName;
        this.addCentreForm.controls['CountryId'].setValue(this.centreModel.countryId);
        this.addCentreForm.controls['Group'].setValue(this.centreModel.groupId);
        this.addCentreForm.controls['VatId'].setValue(this.centreModel.vatId);
        this.addCentreForm.controls['CurrencyId'].setValue(this.centreModel.currencyId);
        // this.centreModel.timeZoneId = data['timeZoneId'] || '';
        ValidationService.removeValidators(this.addCentreForm.controls['NewGroup']);
      });
  }

  onGroupChange(event) {
    const roleName = this.addCentreForm.value.Group;
    if (roleName === this.defaultGroupOption) {
      ValidationService.attachRequired(this.addCentreForm.controls['NewGroup'], []);
    } else {
      if (this.addCentreForm.controls.NewGroup.value) {
        this.addCentreForm.controls.NewGroup.setValue('');
      }
      ValidationService.removeRequired(this.addCentreForm.controls['NewGroup'], []);
    }
  }

  onCurrencyChange(event) {
    this.manageCentreService.getCentreByCurrency(event.target.value).subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.centreData = data;
        }
      }
    );
  }

  addCentre() {
    const formData = new FormData();
    if (this.logoImage) {
      formData.append('logoFile', this.logoImage, this.logoImage.name);
    }
    if (this.signatureImage) {
      formData.append('signatureFile', this.signatureImage, this.signatureImage.name);
    }
    formData.append('data', JSON.stringify(this.addCentreForm.value));
    this.manageCentreService.addCentre(formData).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.dialogService.openSuccessDialog({ message: data.message });
          // close dialog
          this.onCloseDialog(true);
        }
      },
      error => {

      }
    );
  }

  editCentre() {
    const formData = new FormData();
    if (this.logoImage) {
      formData.append('logoFile', this.logoImage, this.logoImage.name);
    }
    if (this.signatureImage) {
      formData.append('signatureFile', this.signatureImage, this.signatureImage.name);
    }
    this.addCentreForm.controls['CurrencyId'].enable();
    formData.append('data', JSON.stringify(this.addCentreForm.value));
    this.manageCentreService.editCentre(this.data.id, formData).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.dialogService.openSuccessDialog({ message: data.message });
          // dispatch change centre info event to header component
          if (this.data.id === localStorage.getItem(AppConstants.localStorage.centreId)) {
            localStorage.setItem(AppConstants.localStorage.centreName, this.addCentreForm.controls['Name'].value);
            this.dialogRef.close({ centreName: this.addCentreForm.controls['Name'].value });
          } else {
            this.onCloseDialog(true);
          }
        }
      },
      error => {
        this.addCentreForm.controls['CurrencyId'].disable();
      }
    );
  }

  onChangeLogo(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      if (this.utility.isMapImageRule(file)) {
        this.logoImage = file;
        // hide choose file button
        event.target.hidden = true;
        this.addCentreForm.controls['IsClinicLogoDelete'].setValue(false);
        this.addCentreForm.controls['ClinicLogoName'].setValue(this.logoImage.name);
      } else {
        // show error popup
        this.dialogService.openErrorDialog({ message: this.fileErrorMessage });
      }
    }
  }

  onRemoveLogo(event) {
    this.addCentreForm.controls['IsClinicLogoDelete'].setValue(true);
    this.addCentreForm.controls['ClinicLogoName'].setValue('');
    this.logoImage = null;
    this.centreModel.clinicLogoName = '';
    // get input file and set value to null
    const fileInput = event.target.parentElement.parentElement.nextElementSibling.nextElementSibling;
    fileInput.value = '';
  }

  onChangeSignature(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      if (this.utility.isMapImageRule(file)) {
        this.signatureImage = file;
        // hide choose file button
        event.target.hidden = true;
        this.addCentreForm.controls['IsSignatureDelete'].setValue(false);
        this.addCentreForm.controls['SignatureName'].setValue(this.signatureImage.name);
      } else {
        // show error popup
        this.dialogService.openErrorDialog({ message: this.fileErrorMessage });
      }
    }
  }

  isValidCopyMasterData(control: AbstractControl) {
    const value = control.value;
    if (!value) {
      return { 'errorCopyMasterData': true };
    }
    return null;
  }

  onRemoveSignature(event) {
    this.addCentreForm.controls['IsSignatureDelete'].setValue(true);
    this.addCentreForm.controls['SignatureName'].setValue('');
    this.signatureImage = null;
    this.centreModel.signatureName = '';
    // get input file and set value to null
    const fileInput = event.target.parentElement.parentElement.nextElementSibling.nextElementSibling;
    fileInput.value = '';
  }

  onVatChange(event) {
    this.addCentreForm.value.VatId = event.value;
  }


  onCloseDialog(data = false) {
    this.dialogRef.close(data);
  }

  onSubmit() {
    // check edit or add mode before call submit data
    if (this.addCentreForm.valid) {
      // update form Group if user set NewGroup
      const tempGroup = this.addCentreForm.controls.Group.value;
      if (this.usertype !== UserType.SystemAdmin && this.addCentreForm.value.CentreCloneId === null) {
        // show error popup
        this.dialogService.openErrorDialog({ message: AppMessages.center.isSystemadmim });
      }
      if (this.addCentreForm.value.NewGroup !== '') {
        this.addCentreForm.controls.Group.setValue(null);
      }
      if (this.data.id) {
        this.editCentre();
      } else {
        this.addCentre();
      }
      if (this.addCentreForm.value.NewGroup !== '') {
        this.addCentreForm.controls.Group.setValue(tempGroup);
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-centre/centre-popup.component.ts